import * as types from "../actions/actionTypes";

export const FILTERS = ["All", "Yours", "Offline", "Sung before"];

export const initialCatalogState = {
  searchValue: "",
  searchSongs: [],
  topSongs: [],
  sungBefore: [], // songs sung in this host's sessions (loaded for the filter)
  loadedSongs: {}, // songs fetched with their verses for a song page, by id
  filter: "All",
  isSearching: false,
};

const replaceSong = (songs, song) => songs.map((s) => (s.Id === song.Id ? { ...s, ...song } : s));

export default function catalogReducer(state = initialCatalogState, action) {
  switch (action.type) {
    case types.CATALOG_SEARCH_CHANGE: {
      const searching = action.term.trim().length > 0;
      return {
        ...state,
        searchValue: action.term,
        searchSongs: searching ? state.searchSongs : [],
        isSearching: searching,
      };
    }

    case types.CATALOG_SEARCH_RESULTS:
      // ignore results that arrive after the search term has changed
      return action.term === state.searchValue
        ? { ...state, searchSongs: action.songs || [], isSearching: false }
        : state;

    case types.CATALOG_SEARCH_FAILED:
      return action.term === state.searchValue ? { ...state, isSearching: false } : state;

    case types.CATALOG_TOP_SONGS:
      return { ...state, topSongs: action.songs || [] };

    case types.CATALOG_SUNG_BEFORE:
      return { ...state, sungBefore: action.songs || [] };

    case types.CATALOG_SET_FILTER:
      return FILTERS.includes(action.filter) ? { ...state, filter: action.filter } : state;

    case types.SONG_UPDATED:
    case types.CATALOG_SONG_LOADED:
      return {
        ...state,
        searchSongs: replaceSong(state.searchSongs, action.song),
        topSongs: replaceSong(state.topSongs, action.song),
        sungBefore: replaceSong(state.sungBefore, action.song),
        loadedSongs: { ...state.loadedSongs, [action.song.Id]: { ...state.loadedSongs[action.song.Id], ...action.song } },
      };

    case types.SONG_DELETED: {
      const { [action.songId]: removed, ...loadedSongs } = state.loadedSongs;
      void removed;
      return {
        ...state,
        searchSongs: state.searchSongs.filter((song) => song.Id !== action.songId),
        topSongs: state.topSongs.filter((song) => song.Id !== action.songId),
        sungBefore: state.sungBefore.filter((song) => song.Id !== action.songId),
        loadedSongs,
      };
    }

    default:
      return state;
  }
}
